<template>
    <form @submit.prevent="onSubmit">
        <v-row>
            <!-- titulo form -->
            <v-col cols="12">
                <h3>Preview</h3>
            </v-col>

            <v-col cols="12" class="justify-center d-flex">
                <PreviewRelacion
                    :relacion="localRelacion"
                    :tratamiento="tratamientoSelected"
                />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <h3>Detalles</h3>
            </v-col>

            <v-col cols="12" md="6">
                <v-text-field
                    label="code"
                    v-model="localRelacion.code"
                    disabled
                    outlined
                    hide-details
                />
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field
                    label="code parent"
                    v-model="localRelacion.code_parent"
                    disabled
                    outlined
                    hide-details
                />
            </v-col>

            <v-col cols="12" >
                <v-text-field
                    label="Título de página"
                    v-model="localRelacion.page_titulo"
                />
            </v-col>
            <v-col cols="12">
                <v-select
                    :items="tratamientos"
                    item-text="nombre"
                    item-value="idtratamiento"
                    v-model="localRelacion.idtratamiento"
                    label="Tratamiento"
                    hide-details
                >
                    <template #append-outer>
                        <v-btn
                            icon
                            color="primary"
                            @click.stop="$emit('add:tratamiento')"
                            title="Agregar tratamiento"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                    <template #item="{ item }">
                        <div class="py-3">
                            <strong>{{ item.nombre }}</strong>
                            <div class="text--secondary text-caption">
                                {{ reduceText(item.descripcion, 50) }}
                            </div>
                        </div>
                    </template>
                    <template #selection="{ item }">
                        <div class="py-3">
                            <strong>{{ item.nombre }}</strong>
                            <div class="text--secondary text-caption">
                                {{ reduceText(item.descripcion, 50) }}
                            </div>
                        </div>
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12">
                <v-text-field
                    label="Posición"
                    v-model="localRelacion.posicion"
                    type="number"
                    :min="0"
                />
            </v-col>
            <v-col cols="12">
                <v-switch
                    label="Mostrar precio"
                    v-model="localRelacion.show_precio"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>
            <v-col cols="12" v-if="localRelacion.show_precio">
                <v-text-field
                    label="Precio"
                    v-model="localRelacion.precio"
                    type="number"
                    :min="0"
                />
            </v-col>
            <v-col cols="12">
                <v-switch
                    label="Precio gratis por luz azul"
                    v-model="localRelacion.precio_gratis_por_luz_azul"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>
            <v-col cols="12">
                <v-switch
                    label="Mostrar modal"
                    v-model="localRelacion.show_icon_info"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>
            <v-col cols="12" v-if="localRelacion.show_icon_info">
                <v-select
                    :items="modales"
                    item-text="titulo"
                    item-value="id"
                    label="Modal"
                    v-model="localRelacion.idmodal"
                    :clearable="true"
                    required
                    hide-details
                >
                     <template #append-outer>
                        <v-btn
                            icon
                            small
                            color="primary"
                            @click.stop="$emit('add:modal')"
                            title="Agregar modal"
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12">
                <v-switch
                    label="Mostrar imagen en ves de nombre"
                    v-model="localRelacion.show_nombre_imagen"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>
            <!-- <v-col cols="12">
                <v-switch
                    label="Añadir separador"
                    v-model="localRelacion.add_separador"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col> -->
            <v-col cols="12">
                <v-switch
                    label="Resaltar nombre"
                    v-model="localRelacion.nombre_resaltado"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>
            <v-col cols="12">
                <v-switch
                    label="Mostrar imagen"
                    v-model="localRelacion.show_img"
                    :true-value="1"
                    :false-value="0"
                />
            </v-col>
            <v-col cols="12" class="form-accion">
                <div>
                    <v-btn text color="red" @click="onDelete" v-if="localRelacion.id">
                        <v-icon left>mdi-delete</v-icon>
                        Eliminar
                    </v-btn>
                </div>
                <div>
                    <v-btn text @click="onCancel">
                        <v-icon left>mdi-cancel</v-icon>
                        Cancelar
                    </v-btn>
                    
                    <v-btn color="primary" type="submit">
                        <v-icon left>mdi-content-save</v-icon>
                        Guardar
                    </v-btn>
                </div>
            </v-col>

            
        </v-row>
    </form>
</template>

<script>
import { tratamientoRelacion } from '@/models/tratamientoRelacion';
import PreviewRelacion from './PreviewRelacion.vue';

export default {
    name: "FormRelacion",
    components: {
        PreviewRelacion
    },
    props: {
        relacion: {
            type: Object,
            default: () => ({
                ...tratamientoRelacion
            })
        },
        tratamientos: {
            type: Array,
            required: true
        },
        modales: {
            type: Array,
            required: false
        }
    },
    data(){
        return {
            localRelacion: { ...this.relacion }
        }
    },
    watch: {
        relacion: {
            handler(newVal) {
                this.localRelacion = { ...newVal };
            },
            deep: true
        }
    },
    emits: ['submit', 'cancel', 'add:tratamiento', 'add:modal'],
    computed: {
        tratamientoSelected() {
            return this.tratamientos.find(t => t.idtratamiento === this.localRelacion.idtratamiento) || null;
        }  
    },
    methods: {
        onSubmit() {
            this.$emit('submit', this.localRelacion);
        },
        onCancel() {
            this.$emit('cancel');
        },
        onDelete() {
            this.$store.dispatch('relaciones/deleteRelacion', this.localRelacion);
        }
    }
    
}
</script>

<style scoped>
    .form-accion{
        display: flex;
        justify-content: space-between;
        gap: 1rem;
    }
</style>